import { render } from "./GreenHouseSolarClientCreate.vue?vue&type=template&id=59987584&scoped=true"
import script from "./GreenHouseSolarClientCreate.vue?vue&type=script&lang=js"
export * from "./GreenHouseSolarClientCreate.vue?vue&type=script&lang=js"

import "./GreenHouseSolarClientCreate.vue?vue&type=style&index=0&id=59987584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59987584"]])

export default __exports__